<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-without-heading" epub:type="chapter" id="unnumbered-1" role="doc-chapter">
<div class="text" id="unnumbered-1-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><b>Jonni K</b></p>
<p class="alignment-block-content alignment-block-content-left"><b>The Ungendered Tour of Europe</b></p>
<p class="alignment-block-content alignment-block-content-left"><b>Calendar</b></p>
</div>
</div>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">Monday 05 Feb — Travel day, crew only — London</p>
<p class="alignment-block-content alignment-block-content-left">Tuesday 06 — Travel day — London</p>
<p class="alignment-block-content alignment-block-content-left">Wednesday 07 — ISSTADION — Stockholm</p>
<p class="alignment-block-content alignment-block-content-left">Thursday 08 — Day off — Copenhagen</p>
<p class="alignment-block-content alignment-block-content-left">Friday 09 — FORUM — Copenhagen</p>
<p class="alignment-block-content alignment-block-content-left">Saturday 10 — SPORTHALLE — Hamburg</p>
<p class="alignment-block-content alignment-block-content-left">Sunday 11 — Day off — Hamburg</p>
<p class="alignment-block-content alignment-block-content-left">Monday 12 — SEIDENSTICKER HALLE — Bielefeld</p>
<p class="alignment-block-content alignment-block-content-left">Tuesday 13 — Day off — Berlin</p>
<p class="alignment-block-content alignment-block-content-left">Wednesday 14 — VELODROM — Berlin</p>
<p class="alignment-block-content alignment-block-content-left">Thursday 15 — MITSUBISHI ELECTRIC HALLE —Dusseldorf</p>
<p class="alignment-block-content alignment-block-content-left">Friday 16 — Day off — Amsterdam/Rotterdam</p>
<p class="alignment-block-content alignment-block-content-left">Saturday 17 — AHOY — Rotterdam</p>
<p class="alignment-block-content alignment-block-content-left">Sunday 18 — FOREST NATIONAL — Brussels</p>
<p class="alignment-block-content alignment-block-content-left">Monday 19 — Day off — Brussels/Frankfurt</p>
<p class="alignment-block-content alignment-block-content-left">Tuesday 20 — FESTHALLE — Frankfurt</p>
<p class="alignment-block-content alignment-block-content-left">Wednesday 21 — ARENA — Nuremberg</p>
<p class="alignment-block-content alignment-block-content-left">Thursday 22 — Day off — Stuttgart</p>
<p class="alignment-block-content alignment-block-content-left">Friday 23 — MARTINSHLEYERHALLE — Stuttgart</p>
<p class="alignment-block-content alignment-block-content-left">Saturday 24 — OLYMPIAHALLE — Munich</p>
<p class="alignment-block-content alignment-block-content-left">Sunday 25 — Travel day — Vienna</p>
<p class="alignment-block-content alignment-block-content-left">Monday 26 — Day off — Vienna</p>
<p class="alignment-block-content alignment-block-content-left">Tuesday 27 — STADTHALLE — Vienna</p>
<p class="alignment-block-content alignment-block-content-left">Wednesday 28 — Travel day — Paris</p>
<p class="alignment-block-content alignment-block-content-left">Thursday 29 — ZENITH — Paris</p>
<p class="alignment-block-content alignment-block-content-left">Friday 01 Mar — Travel day — Home</p>
</div>
</div>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><i>Official tour lists of the Band and the Crew are at the back of the book.</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// the-ungendered-tour-of-europe.vue?3a819bb0